import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { projectId: Number, cardId: Number }
  static targets = ["addInput", "addContainer"]

  removeTag(event) {
    event.preventDefault()
    event.stopPropagation()

    const tagToRemove = event.params.name
    const currentTags = this.currentTags()
    const newTags = currentTags.filter(t => t !== tagToRemove)

    this.updateTags(newTags)
  }

  showAdd(event) {
    event.preventDefault()
    event.stopPropagation()

    this.addContainerTarget.classList.remove("hidden")
    this.addInputTarget.focus()
  }

  stopClick(event) {
    event.stopPropagation()
  }

  hideAdd(event) {
    event.stopPropagation()
    this.addContainerTarget.classList.add("hidden")
    this.addInputTarget.value = ""
  }

  submitAdd(event) {
    event.preventDefault()
    event.stopPropagation()

    const newTag = this.addInputTarget.value.trim()
    if (!newTag) return

    const currentTags = this.currentTags()
    if (!currentTags.includes(newTag)) {
      currentTags.push(newTag)
    }

    this.addInputTarget.value = ""
    this.addContainerTarget.classList.add("hidden")
    this.updateTags(currentTags)
  }

  currentTags() {
    const card = this.element.closest("[data-tag-names]")
    const tagString = card?.dataset.tagNames || ""
    return tagString ? tagString.split(",") : []
  }

  async updateTags(tags) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const url = `/projects/${this.projectIdValue}/cards/${this.cardIdValue}`

    const params = new URLSearchParams()
    if (tags.length === 0) {
      // Send empty string to clear all tags
      params.append("card[tag_list][]", "")
    } else {
      tags.forEach(tag => params.append("card[tag_list][]", tag))
    }

    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": csrfToken
        },
        body: params
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      }
    } catch (error) {
      // Silently fail — card won't update visually, indicating the error
    }
  }
}
